module.exports = __webpack_public_path__ + "images/c925c20af491b16d9d55a8e0d63067d9.jpg";